import React, { Component } from "react";
import { connect } from "react-redux";

import { setCurrentUserFavoriteColor, removeCurrentUserFavoriteColor } from "../../store/user";

import { Sidebar, Menu, Divider, Button, Modal, Icon, Label } from "semantic-ui-react";
import { SliderPicker } from "react-color";
import { setCurrentUserColorOnDoc } from "../utils/misc";

class ColorPanel extends Component {
    state = {
        show: false,
        modalOpen: false,
        primary: this.props.currentUserColors[0]?.primary || "",
        secondary: this.props.currentUserColors[0]?.secondary || "",
    };

    showModal = () => this.setState({ modalOpen: true });

    closeModal = () => this.setState({ modalOpen: false });

    onPickColors = (color, propKey) => this.setState({ [propKey]: color.hex });

    applyColors = () => {
        const { primary, secondary } = this.state;

        if (!primary || !secondary) return;

        this.props.setCurrentUserFavoriteColor({ primary: primary, secondary: secondary });

        this.closeModal();
    };

    renderCurrentUserFavoriteColor = ({ id, primary, secondary }) => (
        <div className="color-container" key={id}>
            <div className="color-wrapper" onClick={() => setCurrentUserColorOnDoc({ id, primary, secondary })}>
                <div className="color-square" style={{ backgroundColor: primary }}>
                    <div className="color-overlay" style={{ backgroundColor: secondary }}></div>
                </div>
            </div>

            <Icon name="trash" className="remove-color" onClick={() => this.props.removeCurrentUserFavoriteColor(id)} />
        </div>
    );

    render() {
        const { show, modalOpen, primary, secondary } = this.state;
        const { setShowMetaPanel, showMetaPanel, currentUserColors, channels } = this.props;

        return (
            <Sidebar
                as={Menu}
                icon="labeled"
                inverted
                vertical
                visible={show}
                width="very thin"
                className="color-panel"
                animation="push">
                <Button icon="add" size="small" onClick={this.showModal} />

                {/* //> Current User Colors */}
                {currentUserColors.map(this.renderCurrentUserFavoriteColor)}

                {!channels.isPrivateChannel && (
                    <Button
                        className="meta-panel--toggler-btn"
                        icon="info"
                        size="small"
                        onClick={() => setShowMetaPanel(!showMetaPanel)}
                    />
                )}

                <Button
                    className="toggler-btn"
                    icon={show ? "hide" : "eye"}
                    size="small"
                    onClick={() => this.setState({ show: !show })}
                />

                {/* //> Color picker modal */}
                <Modal className="color-picker--modal" basic open={modalOpen} onClose={this.closeModal}>
                    <Modal.Header>choose app colors</Modal.Header>

                    <Modal.Content>
                        <Label content="primary color" />
                        <SliderPicker
                            color={primary}
                            onChange={color => this.onPickColors(color, "primary")}
                            onChangeComplete={color => this.onPickColors(color, "primary")}
                        />

                        <Divider />

                        <Label content="secondary color" />
                        <SliderPicker
                            color={secondary}
                            onChange={color => this.onPickColors(color, "secondary")}
                            onChangeComplete={color => this.onPickColors(color, "secondary")}
                        />
                    </Modal.Content>

                    <Modal.Actions>
                        <Button inverted onClick={this.applyColors}>
                            <Icon name="checkmark" /> save colors
                        </Button>
                        <Button color="red" inverted onClick={this.closeModal}>
                            <Icon name="remove" /> cancel
                        </Button>
                    </Modal.Actions>
                </Modal>
            </Sidebar>
        );
    }
}

const mapStateToProps = ({ user: { currentUserColors } }) => ({ currentUserColors });

export default connect(mapStateToProps, { setCurrentUserFavoriteColor, removeCurrentUserFavoriteColor })(ColorPanel);
